import './jq/jquery.toShowHide'
import './jq/jquery-ui.min'
import './jq/jquery.toShowHide'
import './jq/jquery.cookie'
import './jq/jquery.placeholder.min'
import './jq/jquery.carouFredSel'
import './jq/jquery.videoPlayer'

import renderSliders from './carousels/list-carousels'
import renderIcons from './icons/renderIcons'
import getActiveProgram from './utils/getActiveProgram'
import getTimeZone from './utils/getTimeZone'
import printBlock from './utils/printBlock'
import burgerMenu from './utils/burgerMenu'
import CookieWidget from './utils/cookieWidget'
// import videoPlayer from "./player/videoPlayer";


import './css/app.scss'

$.fn.equalizeHeights = function () {
	var maxHeight = this.map(function (i, e) {
		return $(e).height()
	}).get()

	return this.css({
		minHeight: Math.max.apply(this, maxHeight),
	})
}
$.fn.sliceHeight = function (opt) {
	var options = $.extend(
		{
			slice: null,
			el: null,
		},
		opt
	)

	options.slice = options.slice ? options.slice : $(this).find(options.el).size()
	$(this).each(function () {
		var el = $(this).find(options.el)
		for (var i = 0; i < el.length; i += options.slice) {
			$(el.slice(i, i + options.slice)).equalizeHeights()
		}
	})
}
document.addEventListener('DOMContentLoaded', () => {
	burgerMenu()
	renderSliders()
	renderIcons()
	getActiveProgram()
	getTimeZone()
	printBlock()

	$('input[placeholder], textarea[placeholder]').placeholder()

	$('.site-header .search').toShowHide({
		button: 'a.bt',
		box: '.box',
		effect: 'slide',
		anim_speed: 200,
	});
//	videoPlayer()
const cookieWidget = new CookieWidget({
    cookieName: 'Haha',
    cookieExpiryHrs: 48, // Cookie на 48 часов
    cookieTheme: '', // сейчас 2 темы: дефолтная и тёмная
    cookieHtml: null, // если надо заменить html виджета
    cookieScroll: 100 // если задан, то виджет инициализируется по скроллу, типа 100px
});

})
window.addEventListener('load', () => {
	document.querySelector('.load').classList.remove('load')
})
